export default {
    admin: 'Admin',
    customer: 'Customer',
    anonymous: 'Anonymous',
    self: 'Self',
    date: 'Date',
    operator_type: 'Operator type',
    operator_name: 'Operator name',
    status: 'Status',
    action_type: 'Action type',
    action_value: 'Action value',
    order_created: 'Order created',
    note_added: 'Note added',
    payment_recorded: 'Payment recorded',
    order_canceled: 'Order canceled',
    leg_canceled: 'Leg canceled',
    contact_info_updated: 'Contact info updated',
    vehicle_info_updated: 'Vehicle info updated',
    ticket_email_sent: 'Ticket email sent',
    fee_applied: 'Fee applied',
    leg_fee_applied: 'Leg fee applied',
    refund_issued: 'Refund issued'
}
